import React, { useEffect, useState } from "react";
import DTOSalaryAdjustmentARModal from "./DTOSalaryAdjustmentARModal";
import SalaryAdjustmentARModalPresenter from "./SalaryAdjustmentARModalPresenter";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../infra/hooks";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const SalaryAdjustmentARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [daActions, setDaActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOSalaryAdjustmentARModal
        setAllActions={(act: any) => setDaActions(act)}
      />

      <SalaryAdjustmentARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        allActions={daActions}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default SalaryAdjustmentARModalController;
